export const Marquee = () => {
  const text = "THE ACCOUNTABILITY LEDGER — NO EXCUSES — DECLARE IT — PROVE IT — OWN IT — ";
  return (
    <div className="relative flex overflow-hidden border-y border-[#1F1F1F] bg-black py-6 select-none">
      <div className="flex shrink-0 animate-marquee whitespace-nowrap">
        {[0, 1].map((i) => (
          <span
            key={i}
            aria-hidden={i === 1}
            className="font-display text-5xl uppercase tracking-tight text-[#242424] md:text-7xl"
          >
            {text.repeat(2)}
          </span>
        ))}
      </div>
    </div>
  );
};
